import React, { useState } from 'react';

export default function SearchModal({ isOpen, onClose, onSelectResult }) {
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!query.trim()) return;

        setIsSearching(true);
        setError('');
        setResults([]);

        try {
            const response = await fetch(`https://api.alquran.cloud/v1/search/${encodeURIComponent(query)}/all/quran-simple-clean`);
            const data = await response.json();

            if (data.code === 200) {
                setResults(data.data.matches);
            } else {
                setError(data.data || 'حدث خطأ في البحث');
            }
        } catch (err) {
            console.error(err);
            setError('خطأ في الاتصال');
        } finally {
            setIsSearching(false);
        }
    };

    return (
        <div className="search-modal-overlay" onClick={onClose}>
            <div className="search-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="search-header">
                    <h2>البحث في القرآن الكريم</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>

                <form onSubmit={handleSearch} className="search-form">
                    <input
                        type="text"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        placeholder="أدخل كلمة أو عبارة للبحث..."
                        autoFocus
                        className="quran-search-input"
                    />
                    <button type="submit" disabled={isSearching} className="search-submit-btn">
                        {isSearching ? 'جاري البحث...' : 'بحث'}
                    </button>
                </form>

                {error && <div className="search-error">{error}</div>}

                <div className="search-results">
                    {results.length > 0 && <div className="results-count">تم العثور على {results.length} نتيجة</div>}

                    {results.map((match) => (
                        <div
                            key={`${match.surah.number}-${match.numberInSurah}`}
                            className="search-result-item"
                            onClick={() => onSelectResult(match.surah.number, match.numberInSurah)}
                        >
                            <div className="search-result-text">{match.text}</div>
                            <div className="search-result-meta">
                                <span className="surah-badge">{match.surah.name}</span>
                                <span className="ayah-badge">آية: {match.numberInSurah}</span>
                            </div>
                        </div>
                    ))}

                    {!isSearching && results.length === 0 && query && !error && (
                        <div className="no-results">لم يتم العثور على نتائج. اضغط "بحث" للمحاولة.</div>
                    )}
                </div>
            </div>
        </div>
    );
}
